import { render, staticRenderFns } from "./index.vue?vue&type=template&id=533632ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=533632ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533632ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533632ea')) {
      api.createRecord('533632ea', component.options)
    } else {
      api.reload('533632ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=533632ea&scoped=true", function () {
      api.rerender('533632ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/alliance/verify/index.vue"
export default component.exports